import styles from './PresenterPageCard.module.css'
import { useLanguage } from '../contexts/LanguageContext'

function PresenterPageCard({page_title, language}){
    // Language prop is passed from parent component
    return (
        <>
            <h3 className={styles.page_title}>{page_title}</h3>
        </>
    )
}

export default PresenterPageCard
